const Calendario = (momento) => {
  const diaInicial = momento.clone().startOf("month").startOf("week");
  const diaFinal = momento.clone().endOf("month").endOf("week");
  const dia = diaInicial.clone().subtract(1, "day");
  const calendar = [];

  while (dia.isBefore(diaFinal, "day")) {
    calendar.push(
      Array(7)
        .fill(0)
        .map(() => dia.add(1, "day").clone()),
    );
  }

  return calendar;
};

export default Calendario;
